import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminProductSolutionCategories = async (params = {}) => {
    if (!params.languageCode) params.languageCode = 'vi';
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_CATEGORIES.GET_ALL, { params });
    return response.data;
};

export const getAdminProductSolutionCategoryById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_CATEGORIES.GET_BY_ID(id));
    return response.data;
};

export const createProductSolutionCategory = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_CATEGORIES.CREATE, data);
    return response.data;
};

export const updateProductSolutionCategory = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_CATEGORIES.UPDATE(id), data);
    return response.data;
};

export const deleteProductSolutionCategory = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.PRODUCT_SOLUTION_CATEGORIES.DELETE(id));
    return response.data;
};
